module.exports = __webpack_public_path__ + "img/img-classify2.e9e43ce7.png";